<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"
        ><i class="fas fa-edit"></i>&nbsp;Edit</b-button
      >
    </slot>

    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group>
          <b-form-checkbox
            v-model="formValues.tv"
            :value="true"
            :unchecked-value="false"
            >&nbsp;TV</b-form-checkbox
          >
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            v-model="formValues.tvPlayer"
            :value="true"
            :unchecked-value="false"
            >&nbsp;TV Player</b-form-checkbox
          >
        </b-form-group>

        <hr />

        <b-form-group label="Parameters" label-for="parameters-json">
          <b-form-textarea
            id="parameters-json"
            :value="jsonView"
            rows="20"
            max-rows="30"
            readonly
          />
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit"
        >Save</b-button
      >
    </b-modal>
  </span>
</template>

<script>
import Vue from 'vue'

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues()
    }
  },
  props: {
    title: String,
    defaultValues: Object
  },
  computed: {
    jsonView() {
      return JSON.stringify(this.formValues, null, 2)
    }
  },
  methods: {
    getInitialValues() {
      return {
        id: null,
        name: null,
        playerId: null,
        partnerId: null,
        balance: null,
        token: null,
        token2: null,
        currency: null,
        gameType: null,
        tableId: null,
        brandId: null,
        isDemo: false,
        isMobile: false,
        tv: false,
        tvPlayer: false,
        country: null,
        ip: null,
        userAgent: null,
        freeRoundMode: null,
        limitType: null,
        sessionId: null,
        extraData: null,
        transactionId: null,
        tokenTransform: null,
        lastBet: null,
        lastBetLifeTime: null,
        lastBetAt: null,
        lastGetBalance: null,
        lastDebitCountry: null
      }
    },
    setDefaults() {
      let initialValues = this.getInitialValues()

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field])
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field])
        }
      }
    },
    resetModal() {
      this.setDefaults()
    },
    hideModal() {
      this.$refs['modal-container'].hide()
    },
    toggle() {
      this.modalShow = !this.modalShow
    },
    handleSubmit() {
      this.$http({
        url: '/api/v1/aggregator-players/' + this.formValues.id,
        data: {
          tv: this.formValues.tv,
          tvPlayer: this.formValues.tvPlayer
        },
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(() => {
          setTimeout(() => {
            this.$emit('finish')
          }, 500)

          this.hideModal()
          this.$toastr.i('Success')
        })
        .catch(err => {
          this.$toastr.e(JSON.stringify(err.response.data.message))

          throw err
        })
    }
  },
  mounted() {
    this.setDefaults()
  }
}
</script>
